import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";

import Preline from "../../Atoms/Preline";
import Headline from "../../Atoms/Headline";
import Text from "../../Atoms/Text";
import LinkSwitcher from "../../Atoms/Link/LinkSwitcher";

import TranslationContext from "../../../Context/Translation";

import { createMapChart } from "../../../Utils/ChartUtils";

const StandardWorldMap = ({
  properties: {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    countries,
    animation,
  },
}) => {
  const { translation } = useContext(TranslationContext);

  const activeTranslation = translation.find((lang) => lang.active === 1);

  useEffect(() => {
    const amChart = createMapChart(
      `chartdiv_worldmap_${countries.length}`,
      countries,
      activeTranslation.twoLetterIsoCode,
    );

    return () => amChart.dispose();
  }, [countries, activeTranslation]);

  return (
    <div className="container world-map standard">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <Preline preline={subline} />

          <Headline headerType={headerType} headerStyle={headerDisplayStyle} headline={header} />

          {teaser && (
            <div className="mt-xsmall">
              <Text textType="text" text={teaser} />
            </div>
          )}
        </div>
      </div>

      {(headerLink || secondaryLink) && (
        <div className="row justify-content-center mt-small" data-aos={animation.links.default}>
          <div className="col-md-10">
            <div className="links">
              <LinkSwitcher
                linkType={headerLinkType}
                link={headerLink}
                // additionalClasses="btn-lg rounded-pill"
              />

              <LinkSwitcher linkType={secondaryLinkType} link={secondaryLink} />
            </div>
          </div>
        </div>
      )}

      {countries.length > 0 && (
        <div className="row mt-small">
          <div className="col-12">
            <div className="chart">
              <div id={`chartdiv_worldmap_${countries.length}`} className="world_chart" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

StandardWorldMap.propTypes = {
  properties: PropTypes.instanceOf(Object),
};

export default StandardWorldMap;
